import {Box} from 'src/design/atoms/Box';
import {Tooltip} from 'src/design/atoms/Tooltip';
import {IconDots} from '@tabler/icons-react';
import React from 'react';
import {Handle, Position} from '@xyflow/react';
import {JUNCTION_SIZE} from './PhaseJunctionNode';

export const HorizonNode: React.FC = React.memo(() => {
  return (
    <>
      <Handle type="target" position={Position.Left} style={{visibility: 'hidden'}} />
      <Tooltip label="Depth limit reached — this entity may have additional connections" withArrow>
        <Box
          style={{
            width: JUNCTION_SIZE,
            height: JUNCTION_SIZE,
            borderRadius: '50%',
            border: '2px dashed var(--mantine-color-gray-4)',
            background: 'var(--mantine-color-body)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <IconDots size={20} color="var(--mantine-color-gray-6)" />
        </Box>
      </Tooltip>
      <Handle type="source" position={Position.Right} style={{visibility: 'hidden'}} />
    </>
  );
});
